import { Box, IconButton, ThemeProvider, useMediaQuery } from "@mui/material";
import { Outlet } from "react-router-dom";
import { participantTheme } from "../ParticipantAuth/participantTheme";
import LogoutContainer from "./LogoutContainer";
import { useState } from "react";
import { Menu } from "@mui/icons-material";
import ParticipantSidebarWrapper from "./ParticipantSidebarWrapper";

type HeaderProps = {
  setShowDrawer: React.Dispatch<React.SetStateAction<boolean>>;
};

const Header: React.FC<HeaderProps> = ({ setShowDrawer }) => {
  const isMobile = useMediaQuery("(max-width:900px)");

  return (
    <Box
      sx={{
        height: "64px",
        display: "flex",
        alignItems: "center",
        p: "0px 24px",
        bgcolor: "#FFFFFF",
        borderBottom: "1px solid #E5E7EB",
      }}
    >
      {isMobile && (
        <IconButton
          aria-label="menu"
          size="large"
          onClick={() => setShowDrawer(true)}
        >
          <Menu fontSize="inherit" />
        </IconButton>
      )}
      <Box sx={{ ml: "auto" }}>
        <LogoutContainer />
      </Box>
    </Box>
  );
};
const ParticipantLayout = () => {
  const [showDrawer, setShowDrawer] = useState(false);

  return (
    <ThemeProvider theme={participantTheme}>
      <Box sx={{ display: "flex", height: "100%" }}>
        <ParticipantSidebarWrapper
          showDrawer={showDrawer}
          setShowDrawer={setShowDrawer}
        />
        <Box
          sx={{
            flex: 1,
            minWidth: "1px",
            display: "flex",
            flexDirection: "column",
          }}
        >
          <Header setShowDrawer={setShowDrawer} />
          <Box
            sx={{
              flex: 1,
              minHeight: "1px",
              backgroundColor: "#FFF6EB",
              overflow: "auto",
            }}
          >
            <Outlet />
          </Box>
        </Box>
      </Box>
    </ThemeProvider>
  );
};

export default ParticipantLayout;
